import pluralize from 'pluralize'

// Pluralize rules
pluralize.addUncountableRule('accommodation')
